import {useEffect, useState} from "react";

/**
 * Custom hook to detect if a web app is running in a browser tab
 * (not as a standalone Progressive Web App).
 */
export function useInBrowserTab() {
    const [isInBrowserTab, setIsInBrowserTab] = useState(false);

    useEffect(() => {
        // Function to determine if the app is running in a browser tab
        const checkPwaContext = () => {
            const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
                window.navigator.standalone === true; // For Safari
            setIsInBrowserTab(!isStandalone);
        };

        // Perform the initial check
        checkPwaContext();

        // Optionally listen to changes in display mode
        const mediaQuery = window.matchMedia('(display-mode: standalone)');
        const listener = (e) => setIsInBrowserTab(!e.matches);
        mediaQuery.addEventListener('change', listener);

        // Cleanup event listener
        return () => {
            mediaQuery.removeEventListener('change', listener);
        };
    }, []);

    return isInBrowserTab;
}